module.exports = __webpack_public_path__ + "static/media/noblex.728688f0.png";